'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIntermidiatePaths = getIntermidiatePaths;

var _ramda = require('ramda');

// given [ 'a', 'b', 'c' ]
// returns all intermediate paths like
// [ [], ['a'], ['a', 'b'], ['a', 'b', 'c'] ]
function getIntermidiatePaths(path) {
  return (0, _ramda.reduce)(function (visited, current) {
    return (0, _ramda.append)((0, _ramda.append)(current, (0, _ramda.last)(visited)), visited);
  }, [[]], path);
}